import { render } from "./AddTasks.vue?vue&type=template&id=26a1b07b&scoped=true"
import script from "./AddTasks.vue?vue&type=script&lang=js"
export * from "./AddTasks.vue?vue&type=script&lang=js"

import "./AddTasks.vue?vue&type=style&index=0&id=26a1b07b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a1b07b"]])

export default __exports__